module.exports = __webpack_public_path__ + "media/images/icons/vendors/webpic/weddingstops-548e0b497543d71c91976873544ee8cd.webp";